webpackJsonp([195954925044817],{

/***/ 1331:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Soft Skills for Software Developers","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/soft-skills-for-software-developers","createdAt":"2018-02-17T00:12:11.158Z","blogAuthor":{"fields":{"name":"Cynthia Wang ","slug":"blog/author/cynthia-wang"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/1v3CWvtx8E6AcSuYMQ8MCa/8ba799cbebaeb64cf53e92160017213d/blog-post-blog-soft-skills-for-software-developers.jpg"}}}}}]},"authorJson":{"name":"Cynthia Wang ","slug":"blog/author/cynthia-wang","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/cynthia-wang"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-cynthia-wang-931b6a51433d9da84085.js